import React from 'react'

const ConfirmModal = ({ open, isOpen, title, message, onCancel, onClose, onConfirm }) => {
  const isModalOpen = open || isOpen
  if (!isModalOpen) return null
  const handleCancel = onCancel || onClose
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center backdrop-blur-sm bg-black/10">
      <div className="bg-white rounded-[12px] shadow-lg w-full max-w-md p-8 min-h-[250px] flex flex-col justify-center items-center text-center">
        {title && (
          <h3 className="text-lg font-semibold text-[#030303] mb-2">{title}</h3>
        )}
        <p className="text-[#535862] text-sm mb-6">{message}</p>
        <div className="flex justify-center gap-3">
          <button
            onClick={handleCancel}
            className="px-4 py-2 rounded-md border border-[#F0F0F0] text-[#535862] bg-white hover:bg-neutral-50 transition-colors font-medium"
          >
            Cancel
          </button>
          <button
            onClick={onConfirm}
            className="px-4 py-2 rounded-md bg-[#DE3C7D] text-white font-medium hover:bg-[#c8356f] transition-colors"
          >
            OK
          </button>
        </div>
      </div>
    </div>
  )
}

export default ConfirmModal
